export const DetailPageWrapper = ({ head, body, footer, className }) => {
  return (
    <div className={`detail-page-wrapper ${className ? className : ""}`}>
      {head && <div className="detail-page-head">{head}</div>}
      {body && <div className="detail-page-body">{body}</div>}
      {footer && <div className="detail-page-footer">{footer}</div>}
    </div>
  );
};
